module.exports = __webpack_public_path__ + "bye.adaad6ed.png";